import React, { Component } from 'react';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import DataCacheService from '@/shared/services/DataCacheService';
import { dynamicSortMultiple, dynamicSort } from '@/shared/utils/dynamicSort';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import CompanySelector from '@/shared/components/input/CompanySelector';
import DayMonthPicker from '@/shared/components/input/DayMonthPicker';
import UserSearch from '@/shared/components/input/UserSearch';
import EnumSelect from '@/shared/components/input/EnumSelect';
import LanguageSelect from '@/shared/components/input/LanguageSelect';
import EnumMultiSelect from '@/shared/components/input/multiselect/EnumMultiSelect';
import messages from '../relationOverviewMessages';
import Checkbox from '@/shared/components/input/Checkbox';

const sendInvoiceSoftware = 'a85c1650-ba4e-4b8b-af9b-e1b35aef34e1';
const otherSoftware = 'd4d5bf76-55ce-4030-91bb-6416f5636505';

export default class UpdateRelationFieldModal extends Component {
  state = {
    action: 'add',
    fields: [],
    legalForms: [],
    selectedItems: [],
  };
  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  componentDidMount() {
    this.setAvailableFields();
  }
  actionChanged = event => {
    const action = event.target.value;
    this.setState({
      action,
    });
  };
  getLegalForms = () => {
    const { intl } = this.props;
    const dataCache = DataCacheService.getDataCache();
    if (!dataCache || !dataCache.legalForm) return [];
    return dataCache.legalForm
      .map(x => ({
        id: x.id,
        label: intl.formatMessage(listItemMsg('legalform', x.id, x.description || '')),
      }))
      .sort(dynamicSortMultiple('label'));
  };

  setAvailableFields = () => {
    const { intl } = this.props;

    const availableFields = [
      {
        id: '0443d6e0-343d-437f-907c-84235907a5f8',
        label: intl.formatMessage({
          id: `field_0443d6e0-343d-437f-907c-84235907a5f8`.toLowerCase(),
          defaultMessage: 'Legal form',
        }),
      },
      {
        id: 'e31bb7ad-afb4-4a37-bd1e-46d4a9a71cf0',
        label: intl.formatMessage({
          id: `field_e31bb7ad-afb4-4a37-bd1e-46d4a9a71cf0`.toLowerCase(),
          defaultMessage: 'Own company',
        }),
      },
      {
        id: '3117d514-64bc-4c6e-84f7-4a39fbdc51e2',
        label: intl.formatMessage({
          id: `field_3117d514-64bc-4c6e-84f7-4a39fbdc51e2`.toLowerCase(),
          defaultMessage: 'End fiscal year',
        }),
      },
      {
        id: 'ebf5a67c-6ac2-4616-84ea-2b475f279575',
        label: intl.formatMessage({
          id: `field_ebf5a67c-6ac2-4616-84ea-2b475f279575`.toLowerCase(),
          defaultMessage: 'VAT periodicity',
        }),
      },
      {
        id: 'd4f04a11-cdf7-4d85-900f-c1d15df6057f',
        label: intl.formatMessage({
          id: `field_d4f04a11-cdf7-4d85-900f-c1d15df6057f`.toLowerCase(),
          defaultMessage: 'Financial statement scheme',
        }),
      },
      {
        id: 'b33726aa-3dbb-4e6a-afce-219670843eb5',
        label: intl.formatMessage({
          id: `field_b33726aa-3dbb-4e6a-afce-219670843eb5`.toLowerCase(),
          defaultMessage: 'Social secretariat',
        }),
      },
      {
        id: '99c41dc8-a3fb-4843-bbbf-1c558c46f90f',
        label: intl.formatMessage({
          id: `field_99c41dc8-a3fb-4843-bbbf-1c558c46f90f`.toLowerCase(),
          defaultMessage: 'Social security fund',
        }),
      },
      {
        id: 'b094d68c-1c90-422a-a64a-2913b07e02f1',
        label: intl.formatMessage({
          id: `field_b094d68c-1c90-422a-a64a-2913b07e02f1`.toLowerCase(),
          defaultMessage: 'Payment method',
        }),
      },
      {
        id: '56495285-77d0-46bf-951a-4a66e14e1298',
        label: intl.formatMessage({
          id: `field_56495285-77d0-46bf-951a-4a66e14e1298`.toLowerCase(),
          defaultMessage: 'Accounting software',
        }),
      },
      {
        id: '4326316b-07eb-4ef6-889e-6382b38a23a3',
        label: intl.formatMessage({
          id: `field_4326316b-07eb-4ef6-889e-6382b38a23a3`.toLowerCase(),
          defaultMessage: 'Receive invoice software',
        }),
      },
      {
        id: '8a884985-efa6-4faf-8740-6461caf69aed',
        label: intl.formatMessage({
          id: `field_8a884985-efa6-4faf-8740-6461caf69aed`.toLowerCase(),
          defaultMessage: 'Language',
        }),
      },
      {
        id: '246f74be-a60d-46b3-82d7-294dfa227762',
        label: intl.formatMessage({
          id: `field_246f74be-a60d-46b3-82d7-294dfa227762`.toLowerCase(),
          defaultMessage: 'Share register',
        }),
      },
      {
        id: '40ae0a55-fd7d-4577-830f-22589642e875',
        label: intl.formatMessage({
          id: `field_40ae0a55-fd7d-4577-830f-22589642e875`.toLowerCase(),
          defaultMessage: 'Send invoice strategy',
        }),
      },
      {
        id: 'b5813c30-a8f9-4b66-a0d5-236f400c5088',
        label: intl.formatMessage({
          id: `field_b5813c30-a8f9-4b66-a0d5-236f400c5088`.toLowerCase(),
          defaultMessage: 'InvoiceEmailAttachmentOptions',
        }),
      },
      {
        id: '5a9630e2-12c3-4d80-9745-2330bd45ef1a',
        label: intl.formatMessage({
          id: `field_5a9630e2-12c3-4d80-9745-2330bd45ef1a`.toLowerCase(),
          defaultMessage: 'SendInvoicePeppolReady',
        }),
      },
      {
        id: sendInvoiceSoftware,
        label: intl.formatMessage({
          id: `field_a85c1650-ba4e-4b8b-af9b-e1b35aef34e1`.toLowerCase(),
          defaultMessage: 'SendInvoiceSoftware',
        }),
      },
      {
        id: otherSoftware,
        label: intl.formatMessage({
          id: `field_d4d5bf76-55ce-4030-91bb-6416f5636505`.toLowerCase(),
          defaultMessage: 'OtherSoftware',
        }),
      },
    ];

    this.setState({
      fields: availableFields.sort(dynamicSort('label')),
      legalForms: this.getLegalForms(),
    });
  };

  fieldChanged = event => {
    const { fields } = this.state;
    const fieldId = event.target.value;
    const field = fields.find(x => x.id === fieldId);

    this.setState(state => ({
      ...state,
      selectedField: field,
      selectedValue: field.defaultValue ?? undefined,
      selectedItems: [],
      action: 'add',
    }));
  };

  selectedValueChanged = value => {
    this.setState(state => ({
      ...state,
      selectedValue: value,
    }));
  };

  isFormInvalid = () => {
    const { selectedField, selectedValue, selectedItems } = this.state;
    if (!selectedField) return true;

    if (selectedField.id === sendInvoiceSoftware || selectedField.id === otherSoftware) {
      return selectedItems.length === 0;
    }

    if (
      // list of fields that allow null are listed here
      selectedField.id !== '246f74be-a60d-46b3-82d7-294dfa227762' &&
      selectedField.id !== '40ae0a55-fd7d-4577-830f-22589642e875' &&
      selectedField.id !== 'b5813c30-a8f9-4b66-a0d5-236f400c5088' &&
      !selectedValue &&
      selectedValue !== 0
    )
      return true;

    return false;
  };

  onSave = () => {
    const { selectedField, selectedValue, selectedItems, action } = this.state;
    const { onSave } = this.props;

    const fieldUpdate =
      selectedField.id === sendInvoiceSoftware || selectedField.id === otherSoftware
        ? {
            softwares: selectedItems,
            action,
            softwareType:
              selectedField.id === sendInvoiceSoftware ? 'sendInvoiceSoftware' : 'otherSoftware',
          }
        : {
            definition: {
              id: selectedField.id,
            },
            value: selectedValue,
          };

    var endpoint =
      selectedField.id === sendInvoiceSoftware || selectedField.id === otherSoftware
        ? 'softwareupdate'
        : null;

    return onSave(fieldUpdate, endpoint);
  };

  closeModal = () => {
    const { onClose } = this.props;

    this.setState(state => ({
      ...state,
      selectedField: undefined,
      selectedValue: undefined,
    }));

    onClose();
  };

  render() {
    const { show, intl } = this.props;
    const {
      fields,
      selectedField,
      selectedValue,
      legalForms,
      action,
      softwareType,
      selectedItems,
    } = this.state;

    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.UpdateField)}
        show={show}
        onClose={this.closeModal}
        disabled={this.isFormInvalid()}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          <div className="form-group">
            <div className="col-md-6">
              {fields && (
                <select
                  onChange={this.fieldChanged}
                  className="form-control"
                  value={(selectedField && selectedField.id) || ''}
                >
                  {!selectedField && (
                    <option value="">{intl.formatMessage(messages.SelectAField)}</option>
                  )}
                  {fields.map(field => (
                    <option key={field.id} value={field.id}>
                      {field.label}
                    </option>
                  ))}
                </select>
              )}
            </div>
            {selectedField && (
              <div className="col-md-6">
                {(selectedField.id === '68988c03-3b65-4b90-a53a-f4114d9c46bc' ||
                  selectedField.id === '5b5c42ce-0232-43c3-816a-154840dc2b2c' ||
                  selectedField.id === 'bef9f50d-9002-40a0-816f-13c2b507f9f4' ||
                  selectedField.id === '0543ff8b-36bb-4638-b7f6-641484b3ca4b') && (
                  <UserSearch
                    onChange={user => this.selectedValueChanged(user ? user.id : null)}
                    placeholder={intl.formatMessage(messages.SelectAValue)}
                  />
                )}
                {selectedField.id === '0443d6e0-343d-437f-907c-84235907a5f8' && (
                  <select
                    onChange={e => {
                      const value = legalForms.find(x => x.id === parseInt(e.target.value));
                      this.selectedValueChanged(value.id);
                    }}
                    className="form-control"
                    value={selectedValue || ''}
                  >
                    {!selectedValue && selectedValue !== 0 && (
                      <option value="">{intl.formatMessage(messages.SelectAValue)}</option>
                    )}
                    {legalForms &&
                      legalForms.map(legalForm => (
                        <option key={legalForm.id} value={legalForm.id}>
                          {legalForm.label}
                        </option>
                      ))}
                  </select>
                )}

                {selectedField.id === 'e31bb7ad-afb4-4a37-bd1e-46d4a9a71cf0' && (
                  <CompanySelector
                    onChange={this.selectedValueChanged}
                    value={selectedValue}
                    required
                  />
                )}
                {selectedField.id === '3117d514-64bc-4c6e-84f7-4a39fbdc51e2' && (
                  <DayMonthPicker
                    value={undefined}
                    onChange={date => {
                      if (date) {
                        const dateFormatted = `2000-${date.month + 1}-${date.day}`;
                        this.selectedValueChanged(dateFormatted); // backend expects value: "2000-12-31"
                      }
                    }}
                    id="endFiscalYearDate"
                    required
                    outputType="object"
                    block
                    small
                  />
                )}

                {selectedField.id === 'ebf5a67c-6ac2-4616-84ea-2b475f279575' && (
                  <EnumSelect enumType="vatperiodicity" onChange={this.selectedValueChanged} />
                )}
                {selectedField.id === 'd4f04a11-cdf7-4d85-900f-c1d15df6057f' && (
                  <EnumSelect
                    enumType="FinancialStatementScheme"
                    onChange={this.selectedValueChanged}
                  />
                )}
                {selectedField.id === 'b33726aa-3dbb-4e6a-afce-219670843eb5' && (
                  <EnumSelect
                    enumType="SocialSecretariat"
                    onChange={this.selectedValueChanged}
                    orderByLabel
                  />
                )}
                {selectedField.id === '99c41dc8-a3fb-4843-bbbf-1c558c46f90f' && (
                  <EnumSelect
                    enumType="SocialSecurityFund"
                    onChange={this.selectedValueChanged}
                    orderByLabel
                  />
                )}
                {selectedField.id === 'b094d68c-1c90-422a-a64a-2913b07e02f1' && (
                  <EnumSelect
                    enumType="paymentMethod"
                    onChange={this.selectedValueChanged}
                    orderByLabel
                  />
                )}
                {selectedField.id === '56495285-77d0-46bf-951a-4a66e14e1298' && (
                  <EnumSelect
                    enumType="AccountingSoftware"
                    onChange={this.selectedValueChanged}
                    orderByLabel
                  />
                )}
                {selectedField.id === '4326316b-07eb-4ef6-889e-6382b38a23a3' && (
                  <EnumSelect
                    enumType="ReceiveInvoiceSoftware"
                    onChange={this.selectedValueChanged}
                    orderByLabel
                  />
                )}
                {selectedField.id === '8a884985-efa6-4faf-8740-6461caf69aed' && (
                  <LanguageSelect onChange={this.selectedValueChanged} />
                )}
                {selectedField.id === '246f74be-a60d-46b3-82d7-294dfa227762' && (
                  <EnumSelect
                    enumType="ShareRegister"
                    onChange={this.selectedValueChanged}
                    orderByLabel
                    allowNull
                  />
                )}
                {selectedField.id === '40ae0a55-fd7d-4577-830f-22589642e875' && (
                  <EnumSelect
                    enumType="sendInvoiceStrategy"
                    onChange={this.selectedValueChanged}
                    orderByLabel
                    allowNull
                    nullLabel={intl.formatMessage(messages.GeneralSetting)}
                  />
                )}

                {selectedField.id === '5a9630e2-12c3-4d80-9745-2330bd45ef1a' && (
                  <EnumSelect
                    enumType="peppolReadyStatus"
                    onChange={this.selectedValueChanged}
                    orderByLabel
                    allowNull={false}
                  />
                )}
                {selectedField.id === 'b5813c30-a8f9-4b66-a0d5-236f400c5088' && (
                  <EnumSelect
                    enumType="invoiceEmailAttachmentOptions"
                    onChange={this.selectedValueChanged}
                    orderByLabel
                    allowNull
                    nullLabel={intl.formatMessage(messages.GeneralSetting)}
                  />
                )}
                {(selectedField.id === sendInvoiceSoftware ||
                  selectedField.id === otherSoftware) && (
                  <select onChange={this.actionChanged} className="form-control" value={action}>
                    <option value="add">{intl.formatMessage(messages.Add)}</option>
                    <option value="remove">{intl.formatMessage(messages.Remove)}</option>
                    <option value="replace">{intl.formatMessage(messages.Replace)}</option>
                  </select>
                )}
              </div>
            )}
          </div>
          <div className="form-group">
            <div className="col-md-6 col-md-offset-6">
              {selectedField?.id === sendInvoiceSoftware && (
                <EnumMultiSelect
                  type="sendInvoiceSoftware"
                  selection={selectedItems}
                  orderByLabel
                  onChange={value => this.setState({ selectedItems: value })}
                  placeholder={intl.formatMessage(messages.Software)}
                />
              )}

              {selectedField?.id === otherSoftware && (
                <EnumMultiSelect
                  type="otherSoftware"
                  selection={selectedItems}
                  orderByLabel
                  onChange={value => this.setState({ selectedItems: value })}
                  placeholder={intl.formatMessage(messages.Software)}
                />
              )}
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
